
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TermsAndConditionsLearninn, TermsAndConditionsYoutube, TermsAndConditionsWikihow } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const SignUpModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean
  }
})

@Component({
  components: {
    TermsAndConditionsLearninn,
    TermsAndConditionsYoutube,
    TermsAndConditionsWikihow
  }
})

export default class SignUpModal extends SignUpModalProps {
  data () {
    return {
      isLoading: false,
      activeStep: 0,
      step: 0,
      learninnAccepted: false,
      wikihowAccepted: false,
      youtubeAccepted: false,
      voucher: '',
      name: '',
      email: '',
      phone: '',
      signal: '',
      discord: '',
      password: '',
      formDataValid: false,
      left: '<',
      right: '>'
    }
  }

  scrollDown () {
    // window.bottomEl.scrollIntoView()
    setTimeout(() => {
      this.$refs.bottomEl?.scrollIntoView({ behavior: 'smooth' })
    }, 500)
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['voucher', 'name', 'email', 'password', 'learninnAccepted', 'wikihowAccepted', 'youtubeAccepted'], function () {
      this.step = this.learninnAccepted ? this.wikihowAccepted ? this.youtubeAccepted ? 3 : 2 : 1 : 0
      this.activeStep = this.step

      const valid = this.$refs.form.checkValidity()
      this.formDataValid = valid && this.step === 3
    })
    this.$multiwatch(['learninnAccepted', 'wikihowAccepted', 'youtubeAccepted'], function () {
      this.$refs.topEl.$el.scrollIntoView()
    })
  }

  async createUser () {
    try {
      this.isLoading = true

      var data = {
        voucher: this.voucher,
        name: this.name,
        email: this.email,
        pwd: this.password
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/signup`, data)

      this.isLoading = false

      this.$store.commit('loggedIn', true)
      this.$store.commit('accessToken', resp.access_token)
      window.location.href = '/stats'
      // this.$emit('close')
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not Signup. Reason: ${e}`,
        canCancel: false
      })
    }
  }
}
